import api from '@/libs/api'
import store from '@/store'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    storageSettings: null,
    fetchingStorageSettings: false,
    storageSettingsFetched: false,
    savingStorageSettings: false,
  },
  mutations: {
    SET_STORAGE_SETTINGS(state, data) {
      state.storageSettings = data.result
      state.storageSettingsFetched = true
    },
    SET_FETCHING_STORAGE_SETTINGS(state, value) {
      state.fetchingStorageSettings = value
    },
    SET_SAVING_STORAGE_SETTINGS(state, value) {
      state.savingStorageSettings = value
    },
  },
  actions: {
    fetchStorageSettings({ commit }) {
      commit('SET_FETCHING_STORAGE_SETTINGS', true)
      return new Promise((resolve, reject) => {
        api('captain').get(`/projects/${projectId()}/storage`)
          .then(response => {
            commit('SET_STORAGE_SETTINGS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_STORAGE_SETTINGS', false) })
      })
    },
    saveStorageSettings({ commit }, opt) {
      const toPost = opt.new
      const { storage } = opt
      commit('SET_SAVING_STORAGE_SETTINGS', true)
      if (!toPost) {
        return new Promise((resolve, reject) => {
          api('captain').put(`/projects/${projectId()}/storage`, storage)
            .then(response => {
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
            .finally(() => { commit('SET_SAVING_STORAGE_SETTINGS', false) })
        })
      }
      return new Promise((resolve, reject) => {
        api('captain').post(`/projects/${projectId()}/storage`, storage)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_SAVING_STORAGE_SETTINGS', false) })
      })
    },

  },
}
